import { render, staticRenderFns } from "./reportJob.vue?vue&type=template&id=12d810ab&scoped=true"
import script from "./reportJob.vue?vue&type=script&lang=js"
export * from "./reportJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d810ab",
  null
  
)

export default component.exports